export default __webpack_public_path__ + "static/media/007-hammerhead shark.8b799cf1.svg";